<template>
   <div class="drawBox" :style="{ '--styleColor': actInfo.color,'--bgColor': actInfo.bgcolor, left: dragPosition.left, top: dragPosition.top }"
        @mousedown="onDragStart"
        @touchstart="onDragStart"
    >
        <div class="main">
            <!-- <div class="drawNum">0</div> -->
            <img src="@/assets/images/drawBtn.png" alt="" @click="toDraw">            
        </div>
    </div>
</template>

<script>
import { isColorDark } from "@/utils/tool";

export default {
    name: 'DrawBox',
    components: {},
    props: {
        vid: {
            type: Number,
            default: 0
        },
        lotteryid: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            gid:null,
            actInfo:{
                color:'',
                bgcolor:'',
            },
            groups:null,
            list:[],
            keyword:null,
            currPage:1,
            loading: false,
            finished: false,
            refreshing: false,
            isBgDark:false,
            dragPosition: { left: '', top: '' },
            isDragging: false,
            dragStartPos: { x: 0, y: 0 },
        }
    }, 
    created (){
        this.actInfo = this.$store.state.actInfo;
        this.isBgDark = isColorDark(this.actInfo.bgcolor);
    },
    mounted (){
        this.$nextTick(() => {
            if (!this.$el || typeof this.$el.getBoundingClientRect !== 'function') return;
            const rect = this.$el.getBoundingClientRect();
            var windowWidth = window.innerWidth;
            if(windowWidth>1200) {
                this.dragPosition = { left: (rect.left/2+170) + 'px', top: rect.top + 'px' };
            } else {
                this.dragPosition = { left: rect.left + 'px', top: rect.top + 'px' };
            }            
        });
    },
    methods: {
        toDraw() {
            const platform = this.$route.query.platform;
            const tpl = this.actInfo.lottery_tpl;
            const lotteryid = this.lotteryid;
            console.log('lotteryid',lotteryid);
            console.log('tpl',tpl);

            if (!tpl || !lotteryid) return;
            let url = process.env.VUE_APP_WEB_LOTTERY_URL + tpl + 'index?lotteryid=' + lotteryid + '&platform=' + platform;
            // 纵览新闻客户端(3)、河北日报客户端(4)追加app_control参数
            if (platform === '3' || platform === '4') {
                url += '&app_control=1101';
            }
            // window.location.href = url;
            window.open(url);
        },
        getClientPos(e) {
            if (e.touches && e.touches.length > 0) {
                return { x: e.touches[0].clientX, y: e.touches[0].clientY };
            }
            return { x: e.clientX, y: e.clientY };
        },
        onDragStart(e) {
            // 移动端 touchstart 不能 preventDefault，否则会阻止后续 click 事件触发，导致抽奖点击无反应
            if (e.type !== 'touchstart') {
                e.preventDefault();
            }
            this.isDragging = true;
            const pos = this.getClientPos(e);
            this.dragStartPos = { x: pos.x, y: pos.y };

            const onMove = (ev) => {
                if (!this.isDragging) return;
                ev.preventDefault();
                const cur = this.getClientPos(ev);
                const dx = cur.x - this.dragStartPos.x;
                const dy = cur.y - this.dragStartPos.y;
                const el = this.$el;
                const rect = el.getBoundingClientRect();
                const newLeft = rect.left + dx;
                const newTop = rect.top + dy;
                this.dragPosition = {
                    left: newLeft + 'px',
                    top: newTop + 'px',
                };
                this.dragStartPos = { x: cur.x, y: cur.y };
            };

            const onEnd = () => {
                this.isDragging = false;
                document.removeEventListener('mousemove', onMove);
                document.removeEventListener('mouseup', onEnd);
                document.removeEventListener('touchmove', onMove);
                document.removeEventListener('touchend', onEnd);
            };

            document.addEventListener('mousemove', onMove);
            document.addEventListener('mouseup', onEnd);
            document.addEventListener('touchmove', onMove, { passive: false });
            document.addEventListener('touchend', onEnd);
        },
    },
}
</script>

<style lang="scss" scoped>
    .drawBox{
        position: fixed;
        right: 5px;
        bottom: 360px;
        cursor: grab;
        z-index: 999;
        user-select: none;
        .main{
            width: 130px;
            height: 111px;
            position: relative;
            img{
                display: block;
                width: 130px;
                height: 111px;
            }
            .drawNum{
                width: 32px;
                height: 32px;
                background-color: var(--styleColor);
                box-shadow:0px 0px 10px #fff;
                color: #fff;
                font-size: 24px;
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: 12px;
                top: -8px;
            }
        }
        
    }
</style>